<script setup lang="ts">
import { FoodIngredients, FoodNutritionFacts } from '@caks/uikit/food'
import { ButtonMain } from '@caks/uikit/button/'
import { usePositiveNumber } from '@caks/shared/hooks/hooks.positiveNumber'
import { getFoodItemInfo, getFoodItemInfoStopList } from '@caks/shared/api/user.route'
import { InputSwitch } from '@caks/uikit/input'
import { ChipTooltip } from '@caks/uikit/chip'
import { useAccountStore } from '@caks/shared/store/store.account'
import { nextTick, shallowRef, reactive, computed, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { FoodExtraModification, FoodItem } from '@caks/shared/types/types.api'
import {
  CartItem,
  SelectedBaseModificator,
  SelectedModificator,
} from '@caks/shared/types/types.user'
import { InputCheckbox } from '@caks/uikit/input'
import { onClickOutside } from '@vueuse/core'
import { IconCross, IconSmallCross } from '@caks/uikit/icon'

const content = ref<HTMLElement | null>(null)

onClickOutside(content, () => {
  isRemoveIngredientsOpen.value = false
})

const route = useRoute()
const accountStore = useAccountStore()
const router = useRouter()
// todo получаем данные оп родукте с бека

const addedPrice = usePositiveNumber(0)

const props = withDefaults(
  defineProps<{
    desktop: boolean
  }>(),
  {
    desktop: false,
  }
)

const emit = defineEmits<{
  (e: 'addToCart'): void
  (e: 'close'): void
}>()

type Variants = {
  [U: string]: number
}

const baseMods = shallowRef<
  Array<{
    id: number
    name: string
    varaiants: Variants
  }>
>()

const extraIngredients = shallowRef<
  Array<{
    id: number
    name: string
    image: string
    cost: number
  }>
>([])

const mainFoodInfo = shallowRef<{
  id: number
  main_media: string
  name: string
  description: string
  kcal: number
  basePrice: number
} | null>(null)

const nutritionFacts = reactive({
  kcal: 0,
  proteins: 0,
  carbs: 0,
  fats: 0,
  weight: 0,
})

const allFoodInfo = shallowRef<FoodItem | null>(null)

const computedPrice = computed(() => {
  let price = 0

  if (mainFoodInfo.value) {
    price = mainFoodInfo.value?.basePrice
    selectedBaseMods.value.forEach((el) => {
      const findedMod = allFoodInfo.value?.available_modifications.base_modifications.find(
        (mod) => mod.id === el.modification_id
      )

      if (findedMod) {
        const findedVariant = findedMod.available_variants.find((variant) => {
          return variant.id === el.variant_id
        })

        if (findedVariant) {
          if (findedVariant.cost > 0) {
            price = findedVariant.cost
          } else {
            price += findedVariant.cost
          }
        }
      }
    })
  }

  return addedPrice.value + price
})

const changeBjuw = (bjuw: any, action: 'add' | 'remove') => {
  const { kkal, belki, jiri, uglevodi, weight_gramm } = bjuw

  let kcal = (kkal * weight_gramm) / 100
  let proteins = (belki * weight_gramm) / 100
  let carbs = (uglevodi * weight_gramm) / 100
  let fats = (jiri * weight_gramm) / 100
  let weight = weight_gramm
  const newData = { kcal, proteins, carbs, fats, weight }

  if (action === 'add') {
    for (const key in nutritionFacts) {
      nutritionFacts[key as keyof typeof nutritionFacts] += newData[key as keyof typeof newData]
    }
  } else {
    for (const key in nutritionFacts) {
      nutritionFacts[key as keyof typeof nutritionFacts] -= newData[key as keyof typeof newData]
    }
  }

  for (const key in nutritionFacts) {
    nutritionFacts[key as keyof typeof nutritionFacts] = fixed(
      Number(nutritionFacts[key as keyof typeof nutritionFacts])
    )
  }
}

const extraIngredientsSelected = ref<FoodExtraModification[]>([])

const onSelectedIngredient = (value: FoodExtraModification) => {
  extraIngredientsSelected.value.push(value)
  changeBjuw(value.BJUW, 'add')
  addedPrice.value += value.cost
}
const onRemovedIngredient = (value: FoodExtraModification) => {
  extraIngredientsSelected.value = extraIngredientsSelected.value.filter((el) => el.id !== value.id)
  changeBjuw(value.BJUW, 'remove')
  addedPrice.value -= value.cost
}

const chooseMod = (id: string, modId: number) => {
  selectedBaseMods.value.forEach((el) => {
    if (el.modification_id === modId) {
      let approveChange = false

      for (let i = 0; i < el.allVariant.length; i++) {
        if (el.allVariant[i].id === id && el.allVariant[i].cost != 'Нет в наличии') {
          el.variant_name = el.allVariant[i].name
          approveChange = true
        }
      }

      if (approveChange) el.variant_id = id
    }
  })
}
const selectedBaseMods = ref<SelectedBaseModificator[]>([])

onMounted(async () => {
  try {
    setTimeout(async () => {
      let data

      const foodId = route.params.id ?? route.params.foodId

      const res = await getFoodItemInfoStopList(
        foodId as string,
        accountStore.selectedLocation?.iiko_id
      )

      if (res.status === 'ERR') throw res.description ?? res.message

      data = res.data[0]

      const baseVariants = (data as FoodItem).available_modifications.base_modifications

      let tempBaseVariants = baseVariants.map((item) => {
        let tempVaraints = item.available_variants.filter(
          (itemVariant) => itemVariant.cost != 'Нет в наличии'
        )

        return (item.available_variants = [...tempVaraints])
      })

      selectedBaseMods.value = baseVariants.map((el) => {
        return {
          modification_id: el.id,
          name: el.name,
          variant_id: el.available_variants[0].id,
          allVariant: el.available_variants,
          variant_name: el.available_variants[0].name,
        }
      })

      allFoodInfo.value = data as FoodItem

      allFoodInfo.value.available_modifications.ingredients.sort((a, b) => {
        if (a.required && !b.required) return -1
        if (!a.required && b.required) return 1
        return 0
      })
      mainFoodInfo.value = {
        name: data.name,
        description: data.description,
        main_media: data.main_media,
        id: data.id,

        kcal: 0,
        basePrice: data.base_cost,
      }
      const tempBaseMods = data.available_modifications.base_modifications

      baseMods.value = tempBaseMods.map((mod) => {
        const varaiants = {}
        for (const variant of mod.available_variants) {
          //@ts-ignore
          if (variant.cost != 'Нет в наличии') {
            varaiants[variant.name.replace(/[\n\t\r]/g, '')] = variant.id
          }
        }
        return { id: mod.id, name: mod.name, varaiants }
      })

      extraIngredients.value = data.available_modifications.extra_modifications

      calcWeightAndBjuw()
    }, 10)
  } catch (error) {
    console.error(error)
  }
})

const addToCart = () => {
  setTimeout(() => {
    // todo По возможности переделать этот ужас
    if (!accountStore.mockCartItems.length) {
      if (props.desktop) {
        emit('addToCart')
      } else {
        nextTick(() => {
          const token = localStorage.getItem('token')

          if (token) {
            const addressId = localStorage.getItem('addressId')

            if (!addressId) {
              router.push('/delivery/point')
            } else {
              router.push('/')
            }
          } else {
            router.push('/auth/phone')
          }
        })
      }
    } else {
      if (props.desktop) {
        emit('close')
      } else router.push('/')
    }

    if (allFoodInfo.value) {
      const cartExtraMods: SelectedModificator[] = extraIngredientsSelected.value.map((el) => {
        return {
          modification_id: el.id,
          name: el.name,
        }
      })

      const cartRemovedMods: SelectedModificator[] = removedList.value.map((el) => {
        return {
          modification_id: el.id,
          name: el.name,
        }
      })

      const cartItem: Partial<CartItem> = {
        item: allFoodInfo.value,
        extraModificators: cartExtraMods,
        removedModificators: cartRemovedMods,
        baseModificators: selectedBaseMods.value,
        cost: computedPrice.value,
      }

      if (accountStore.profile) {
        // @ts-ignore
        accountStore.addToCart(cartItem)
      } else {
        // @ts-ignore
        accountStore.addToTempCart(cartItem)
      }

      selectedBaseMods.value = []
      //localStorage.setItem('cart', JSON.stringify(accountStore.cart))
    }
  }, 350)
}

const isRemoveIngredientsOpen = ref(false)

function fixed(num: number): number {
  if (Number.isInteger(num)) {
    return num
  } else if (num.toFixed(2).slice(-1) === '0') {
    return Number(num.toFixed(1))
  } else {
    return Number(num.toFixed(2))
  }
}

const calcWeightAndBjuw = () => {
  let kcal = 0
  let proteins = 0
  let carbs = 0
  let fats = 0
  let weight = 0

  if (allFoodInfo.value) {
    const { kkal, belki, jiri, uglevodi, weight_gramm } = allFoodInfo.value.base_bjuw
    kcal += (kkal * weight_gramm) / 100
    proteins += (belki * weight_gramm) / 100
    fats += (jiri * weight_gramm) / 100
    carbs += (uglevodi * weight_gramm) / 100
    weight += weight_gramm
  }

  Object.assign(nutritionFacts, { kcal, proteins, carbs, fats, weight })

  for (const key in nutritionFacts) {
    nutritionFacts[key] = fixed(nutritionFacts[key])
  }
}

const removedCheckboxList = ref([])
const removableList = computed(() => {
  return allFoodInfo.value?.available_modifications.removable_modifications
})
const removedList = computed(() => {
  if (removableList.value) {
    return removableList.value.filter((el) => {
      return removedCheckboxList.value.includes(el.id)
    })
  }
  return []
})
const removeFromRemovedList = (id: string) => {
  removedCheckboxList.value = removedCheckboxList.value.filter((el) => {
    return el !== id
  })
}

const isImageLoading = ref(true)

watch(
  () => accountStore.cart,
  () => {
    localStorage.setItem('cart', JSON.stringify(accountStore.cart))
  }
)
</script>

<template>
  <div class="food__wrapper" :class="{ desktop }">
    <div :class="{ desktop__image: desktop }" v-if="mainFoodInfo">
      <div class="food__image">
        <img :src="mainFoodInfo.main_media" alt="" srcset="" @load="isImageLoading = false" />
      </div>
    </div>

    <div v-if="mainFoodInfo && !isImageLoading" :class="{ desktop__info: desktop }">
      <div v-if="mainFoodInfo" :class="{ desktop__scrollable: desktop }">
        <header class="food__title title">
          <h1 class="title__text" v-text="mainFoodInfo.name" />
          <div class="title__tooltip">
            <chip-tooltip>
              <food-nutrition-facts :nutritionFacts="nutritionFacts" :name="mainFoodInfo.name" />
            </chip-tooltip>
          </div>
        </header>

        <div class="food__weight">{{ nutritionFacts.weight }} грамм</div>

        <div v-if="allFoodInfo" class="food__description">
          <p>{{ allFoodInfo.description }}</p>
        </div>
        <ul v-if="removedCheckboxList.length" class="food__removed-list removed-list">
          <li v-for="item in removedList" :key="item.id" class="removed-list__item">
            <p>{{ item.name }}</p>
            <button @click="removeFromRemovedList(item.id)">
              <icon-small-cross />
            </button>
          </li>
        </ul>
        <div class="food__remove-wrapper">
          <button
            v-if="removableList.length"
            @click="isRemoveIngredientsOpen = true"
            class="food__remove-ingredients"
          >
            Убрать ингредиенты
          </button>
        </div>

        <div
          v-if="isRemoveIngredientsOpen"
          ref="content"
          class="remove"
          :class="{ remove_desktop: desktop }"
        >
          <header class="remove__header">
            <h2 class="remove__title">Убрать ингредиенты</h2>
            <button @click="isRemoveIngredientsOpen = false" class="remove__close">
              <icon-cross />
            </button>
          </header>
          <ul class="remove__checkboxes">
            <li v-for="item in removableList">
              <input-checkbox v-model="removedCheckboxList" :value="item.id">
                <template #label>{{ item.name }}</template>
              </input-checkbox>
            </li>
          </ul>
        </div>

        <div class="food__mods">
          <div class="food__base-mod mod" v-for="mod of baseMods">
            <div class="mod__title" v-text="mod.name" />
            <input-switch
              :modelValue="0"
              @update:modelValue="(id: number) => chooseMod(id, mod.id)"
              :associatedIndexes="Object.values(mod.varaiants)"
              :options="Object.keys(mod.varaiants)"
            />
          </div>
          <div v-if="extraIngredients.length" class="food__extra extra">
            <div class="extra__title">Добавить</div>
            <food-ingredients
              :ingredientsList="extraIngredients"
              @select="onSelectedIngredient"
              @remove="onRemovedIngredient"
            />
          </div>
        </div>
      </div>

      <div v-else-if="!desktop" class="food__loading">
        <slot />
      </div>

      <div v-if="mainFoodInfo" class="food__add">
        <button-main @click="addToCart" ripple class="food__add-btn">
          <template v-slot:default>{{ `В корзину ${computedPrice}₽` }}</template>
        </button-main>
      </div>
    </div>

    <div
      v-if="!mainFoodInfo && isImageLoading"
      class="food__loading"
      :class="{ food__loading_mobile: !desktop }"
    >
      <skeletor class="desktop-loader" />
      <div class="desktop-loader__info">
        <skeletor v-for="i in 5" :class="`info-line-${i}`" />
        <div class="desktop-loader__ingredients">
          <skeletor v-for="_ in 9" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.crossed {
  text-decoration: line-through;
}

.food {
  &__loading {
    display: flex;
    justify-content: center;
    gap: 20px;
    width: 100%;
    height: 540px;
    overflow: hidden;

    &_mobile {
      height: auto;
      flex-direction: column;

      .desktop-loader {
        height: 358px !important;
      }
    }

    .desktop-loader {
      width: 100%;
      height: 100%;
      border-radius: 16px;

      &__info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;

        .info-line-1 {
          background-color: rgba(0, 0, 0, 0.3);
          height: 28px;
        }

        .info-line-2,
        .info-line-3,
        .info-line-4 {
          height: 16px;
        }

        .info-line-2 {
          width: 15%;
        }

        .info-line-3 {
          width: 60%;
        }

        .info-line-4 {
          width: 40%;
        }

        .info-line-5 {
          width: 50%;
        }
      }

      &__ingredients {
        display: grid;
        grid-template-columns: repeat(3, 110px);
        grid-template-rows: repeat(2, 158px);
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
        height: 100%;

        * {
          border-radius: 8px;
        }
      }
    }
  }

  &__image {
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    border-radius: 12px;
    overflow: hidden;

    img {
      max-width: 100%;
    }
  }

  &__title {
    @include h2-1;
    color: $primary-text;
  }

  &__weight {
    @include h5-6;
    color: $sub-text;
    margin-bottom: 16px;
  }

  &__description {
    @include h5-2;
    color: $sub-text;
  }

  .removed-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 16px;

    &__item {
      display: flex;
      align-items: center;
      width: 100%;
      color: $primary-red;
      @include h5-2;

      button {
        height: 16px;
      }
    }
  }

  &__remove-ingredients {
    @include h5-6;
    color: #008443;
    margin-top: 16px;
  }

  &__remove-wrapper {
    position: relative;
  }

  &__mods {
    margin-top: 24px;
  }

  &__base-mod {
    margin-bottom: 24px;
  }

  &__add {
    position: fixed;
    left: 16px;
    right: 16px;
    bottom: calc(16px + #{$safe_area_bottom});
    width: 100%;
    width: calc(100% - 32px);
  }
  &__add-btn {
    width: 100%;
  }
}

.title {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}
.mod {
  &__title {
    @include h4-4;
    color: $primary-text;
    margin-bottom: 16px;
  }
}
.extra {
  &__title {
    @include h4-4;
    color: $primary-text;
    margin-bottom: 16px;
  }
}

.desktop {
  display: flex;
  gap: 32px;
  min-width: 800px;
  min-height: 540px;
  width: 100%;

  .removed-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 16px;

    &__item {
      display: flex;
      align-items: center;
      width: 100%;
      color: $primary-red;
      @include h5-2;

      button {
        height: 16px;
      }
    }
  }

  .food {
    &__add {
      margin-top: auto;
    }
  }

  &__image {
    max-width: 384px;
    max-height: 384px;
    margin: auto 0;
  }

  &__info {
    max-width: 384px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  &__scrollable {
    max-height: 480px;
    height: 480px;
    overflow-y: auto;
    padding: 0 24px 0 12px;

    &::-webkit-scrollbar {
      width: 12px; /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: $ui-gray-2;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $sub-text;
      border-radius: 10px;
      border: 2px solid $ui-gray-2;
    }
  }

  .food {
    &__image {
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
      }
    }

    &__title {
      @include h2-1;
      color: $primary-text;
    }

    &__weight {
      @include h5-6;
      color: $sub-text;
      margin-bottom: 16px;
    }

    &__description {
      @include h5-2;
      color: $sub-text;
      position: relative;
    }

    &__remove-ingredients {
      @include h5-6;
      color: $primary-green;
      margin-top: 16px;
    }

    &__remove-wrapper {
    }

    &__mods {
      margin-top: 24px;
    }

    &__base-mod {
      margin-bottom: 24px;
    }

    &__add {
      position: static;
      margin-top: 16px;
      width: 100%;
    }
    &__add-btn {
      width: 100%;
    }
  }
}

.remove {
  width: 343px;
  max-width: calc(100% - 8px);
  min-height: 200px;
  border-radius: 16px;
  background: $white;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
  padding: 24px 16px;
  position: absolute;
  z-index: 1;
  margin: 0 4px;
  bottom: 24px;
  left: 12px;

  &__header {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
    --svg-col: #{$sub-text};
    color: $primary-text;
    @include h4-6;
  }

  &__checkboxes {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &_desktop {
    top: 210px;
    left: 52.5%;
    z-index: 1;
    max-height: 200px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 12px; /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: $ui-gray-2;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $sub-text;
      border-radius: 10px;
      border: 2px solid $ui-gray-2;
    }
  }
}
</style>
